<template>
<section>
    <div class="login" @click="logout">
        退出
    </div>
</section>
</template>

<script>
// import quc from "@/utils/quc.js";
import { Toast } from "vant";
import { mapState } from 'vuex';
export default {
  created() {
  },
  data() {
    return {
      isLogin: null
    };
  },
  computed: {
    // ...mapState(['isLogin'])
  },
  methods: {
    logout() {
      // window.QHPass.signIn(function(userInfo) {
      //   this.isLogin = userInfo.nickname
      //     ? userInfo.nickname
      //     : userInfo.username;
      //   Toast("登录成功");
      //   window.location.reload();
      // });
      // let params = encodeURIComponent(`http://i.360.cn/login/wap?destUrl=https://home.qihoo.net`);
      let params = window.location.href;
      window.location.href = `http://i.360.cn/login/wap?destUrl=${encodeURIComponent(params)}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  font-weight: bold;
  color: white;
  font-size: 32px;
}
</style>
